export default __webpack_public_path__ + "static/media/heart.f92fa021.svg";